import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/HomeContainer/HomeContainer.js");
